import ArrowRightImage from "../../images/newHome/arrow-right.svg"
import ScanImage from "../../images/newHome/scan.png"
import CertificationImage from "../../images/newHome/certification.png"
import SectionTitle from "./SectionTitle";

function CertificationSection() {
    return (
        <div className="container lg:py-[80px] py-5">
            {/* Header */}
            <div className="max-w-3xl">
                <SectionTitle
                    size="font-inter lg:text-[36px] text-[32px]"
                    weight="font-semibold"
                    color="text-darkTextColor"
                    align="lg:text-left"
                    className="leading-[44px] mb-3"
                >
                    Telcron will let you scan barcode to discover the certification status
                </SectionTitle>
                <p className="font-inter text-center lg:text-left text-xl leading-[30px] text-gray-700 font-normal pb-4">
                    There’s a 50% chance that products fail Electromagnetic Compatibility (EMC) tests the first time, according to at least one leading industry expert.
                </p>
            </div>

            {/* First Info Section */}
            <div className="flex flex-col lg:flex-row items-start gap-10 mb-20 mt-16">
                <div className="lg:w-1/2 w-full">
                    <div className="info-alart border-l-4 border-primaryColor pl-6 w-full">
                        <h5 className="font-inter text-xl leading-[30px] font-semibold text-darkTextColor mb-4">
                            Use the app scan camera to look <br /> inside your packages without opening them
                        </h5>
                        <p className="font-inter text-[16px] leading-[24px] text-gray-700 font-normal mb-4">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean nisi nisl, tempus non volutpat auctor, consequat sit amet magna. In pharetra venenatis turpis, vel venenatis erat ultricies a. Maecenas mattis laoreet elit, at pharetra lorem pharetra id. Vestibulum elementum ac massa sed tincidunt. Suspendisse potenti. Aliquam ac imperdiet lectus. Mauris tempor nunc ac aliquam porttitor. Quisque vitae efficitur purus. Nulla ultricies nulla in augue tincidunt suscipit. Cras a aliquam risus, id venenatis diam.
                        </p>
                        <span className="font-inter text-primaryColor font-semibold inline-flex items-center gap-2 cursor-pointer">
                            Learn More <img src={ArrowRightImage} alt="Next" className="w-4 h-4" />
                        </span>
                    </div>
                </div>
                <div className="lg:w-1/2 w-full">
                    <img src={ScanImage} alt="scan" className="w-full xl:w-[562px]" />
                </div>
            </div>

            <div className="flex flex-col-reverse lg:flex-row items-start gap-10">
                <div className="lg:w-1/2 w-full">
                    <img src={CertificationImage} alt="certification" className="w-full xl:w-[592px] xl:h-[512px]" />
                </div>
                <div className="lg:w-1/2 w-full">
                    <div className="info-alart border-l-4 border-primaryColor pl-6 w-full">
                        <h5 className="font-inter text-[20px] leading-[30px] font-semibold text-darkTextColor mb-4">
                            Find Certification <br /> Information Faster with Product iQ
                        </h5>
                        <p className="font-inter text-[16px] leading-[24px] text-gray-700 font-normal mb-4">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean nisi nisl, tempus non volutpat auctor, consequat sit amet magna. In pharetra venenatis turpis, vel venenatis erat ultricies a. Maecenas mattis laoreet elit, at pharetra lorem pharetra id. Vestibulum elementum ac massa sed tincidunt. Suspendisse potenti. Aliquam ac imperdiet lectus. Mauris tempor nunc ac aliquam porttitor. Quisque vitae efficitur purus. Nulla ultricies nulla in augue tincidunt suscipit. Cras a aliquam risus, id venenatis diam.
                        </p>
                        <span className="font-inter text-primaryColor font-semibold inline-flex items-center gap-2 cursor-pointer">
                            Learn More <img src={ArrowRightImage} alt="Next" className="w-4 h-4" />
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CertificationSection;